import React from "react";
import Alert from "@amzn/meridian/esm/components/alert";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";

import star from "../../../../images/star.svg";
import star_fallback from "../../../../images/star_fallback.png";
import LearnMoreLink from "../../../../components/LearnMoreLink";
import { THEME_COLOR } from "../../../../styles/colors";

/**
 * This component is shown when AiMS is not available for the current meeting.
 * This view appears for hosts in meetings marked as not eligible by the `/is-aims-available` API.
 *
 * - It informs the user that the summarization feature is not approved for this meeting.
 * - It provides a "Learn more" link that opens a wiki page
 */

const AimsNotAvailable = ({ aimsNotAvailableMessage }) => {
  return (
    <Column spacing="none" spacingInset="none">
      <Column height="40px" />
      <Column height="100px">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
            <Box type="outline" spacingInset="none" width="68px" height="20px"></Box>
          </Theme>
          <Box type="outline" spacingInset="none" width="226px" height="100px">
            <Row spacing="none" spacingInset="none">
              <Row spacing="none" spacingInset="none" width="16px" />
              <Column spacing="none" spacingInset="none" width="24px" height="100px">
                <Column spacing="none" spacingInset="none" height="16px" />
                <img src={star} alt="star"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = star_fallback;
                  }}
                />
              </Column>
              <Row spacing="none" spacingInset="none" width="20px" />
              <Column spacing="none" spacingInset="none" width="133px" height="100px">
                <Column spacing="none" spacingInset="none" height="17px" />
                <Text type="h50" alignment="start">
                  Summarize meeting
                </Text>
                <Column spacing="none" spacingInset="none" height="16px" />
                <Alert type="warning" size="small">
                  Not available
                </Alert>
              </Column>
            </Row>
          </Box>
        </Row>
      </Column>

      <Column height="16px" />

      <Row spacing="none">
        <Row width="72px" />
        <Text type="h50" color="secondary" alignment="start">
          Inform attendees if needed
        </Text>
      </Row>

      <Column height="16px" />

      <Row spacing="none">
        <Row width="72px" />
        <Box spacingInset="none" maxWidth="259px">
          <Text type="b200" color="secondary">
            {aimsNotAvailableMessage}
          </Text>
        </Box>
      </Row>
      <Column height="16px"></Column>

      <Row spacing="none">
        <Row width="72px" />
        <LearnMoreLink />
      </Row>
    </Column>
  );
};

export default AimsNotAvailable;